import { legacyColors, legacyTheme } from '~/legacyTheme';

export const useSxStyles = () => {
  return {
    tabHeader: {
      color: legacyTheme.palette.primary.main,
      fontWeight: 'bold',
      fontSize: 15,
    },
    contentPadding: {
      padding: '10px 15px',
      marginBottom: '5px',
    },
    btn: {
      position: 'relative',
      height: '24px',
      top: 0,
      marginLeft: '2px',
      fontSize: 15,
      display: 'inline-block',
      cursor: 'pointer',
      float: 'right',
      border: '1px solid #cccccc',
      borderRadius: '2px',
      backgroundImage: 'linear-gradient(to bottom, #f6f6f6 0%, #eaeaea 100%)',
    },
    btnIcon: {
      margin: '2px 2px 2px 4px',
      color: legacyColors.button.text,
      textRendering: 'auto',
      WebkitFontSmoothing: 'antialiased',
    },
    btnText: {
      margin: '2px 4px 2px 2px',
      color: legacyColors.button.text,
      fontSize: '1em',
    },
    spinner: {
      textAlign: 'center',
      margin: '25px',
    },
  };
};
